import { Component, EventEmitter, Output, OnInit, Input, TemplateRef, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, combineLatest, map, startWith } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { LanguageService } from '@fcom/ui-translate';
import { getQualtricsUrl } from '@fcom/common/qualtrics/qualtrics.utils';
import { ButtonMode, ButtonTheme, IconPosition } from '@fcom/ui-components';
import { AppState } from '@fcom/core';
import { profileOrUndefinedIfNotLoggedIn } from '@fcom/core/selectors';
import { Profile } from '@fcom/core-api/login';

@Component({
  selector: 'fin-bound-selection-error-message',
  templateUrl: 'bound-selection-error-message.component.html',
  standalone: false,
})
export class BoundSelectionErrorMessageComponent implements OnInit {
  private languageService = inject(LanguageService);
  private store$ = inject<Store<AppState>>(Store);

  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly ButtonTheme = ButtonTheme;
  readonly IconPosition = IconPosition;
  readonly ButtonMode = ButtonMode;

  @Input() fromFragment: TemplateRef<unknown>;

  @Input({ required: true }) ctaButtonText: string;

  @Input() enableSurvey = true;

  @Input() qualtricsKey = 'feedback.generalSurveyUrl';

  @Input() surveyButtonText = 'feedback.title';

  /**
   * Emits when the CTA element has been clicked
   * @type {EventEmitter}
   */
  @Output()
  ctaClick: EventEmitter<Event> = new EventEmitter();

  qualtricsUrl$: Observable<string>;

  ngOnInit(): void {
    const profile$ = this.store$.pipe(profileOrUndefinedIfNotLoggedIn(), startWith(undefined as Profile | undefined));
    this.qualtricsUrl$ = combineLatest([
      this.languageService.langKey,
      this.languageService.translate(this.qualtricsKey),
      profile$,
    ]).pipe(
      map((params): string => {
        return getQualtricsUrl(params[0], this.languageService.langValue, params[1], undefined, undefined, params[2]);
      })
    );
  }
}
